import { useEffect, useState } from 'react';
import { IExpectedHoursItem } from '../services/types/expectedHours';
import {
  acceptSettlement as acceptSettlementRequest,
  getExpectedHoursForMonth,
  rejectSettlement as rejectSettlementRequest,
} from '../services/expectedHoursService';
import { monthNames } from '../utils/consts';

export default function useExpectedHours(selectedMonth?: string, selectedYear?: number) {
  const [expectedHours, setExpectedHours] = useState<IExpectedHoursItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const monthIndex = selectedMonth
    ? monthNames.indexOf(selectedMonth)
    : new Date().getMonth();

  const year = selectedYear ?? new Date().getFullYear();

  const fetchData = async () => {
    if (monthIndex < 0 || monthIndex > 12) return;

    setExpectedHours([]);
    setIsLoading(true);
    try {
      const data = await getExpectedHoursForMonth(year, monthIndex + 1); // miesiąc 1-based
      setExpectedHours(data)

    } catch (err) {
      console.error("❌ Błąd pobierania danych:", err);
      setExpectedHours([]);
    } finally {
      setIsLoading(false);
    }
  };

  const acceptSettlement = async (item: IExpectedHoursItem) => {
    await acceptSettlementRequest({
      userId: item.userId,
      year: item.year,
      month: item.month,
    });

    await fetchData();
  };

  const rejectSettlement = async (item: IExpectedHoursItem, rejectionReason: string) => {
    await rejectSettlementRequest({
      userId: item.userId,
      year: item.year,
      month: item.month,
      rejectionReason,
    });

    await fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [monthIndex, year]);

  return {
    expectedHours,
    isLoading,
    getExpectedHours: fetchData,
    acceptSettlement,
    rejectSettlement
  };
}
